import { combineReducers } from "@reduxjs/toolkit";
import definedBenefitAbout from "../defined-benefit-about/defined-benefit-about";

const definedBenefitAboutReducer = combineReducers({
  definedBenefitAbout,
});

export default definedBenefitAboutReducer;
